type Dims = {
    width: number;
    height: number;
};

export type Frame = {
    imageData: ImageData;
    delay: number;
    start: number;
    end: number;
    dims: Dims;
    composedPixels?: Uint8ClampedArray;
};

export default function parseGif(
    arrayBuffer: ArrayBuffer, context: jsx.AppGlobals): Promise<Frame[]> {
    return new Promise<Frame[]>((resolve, reject) => {
        context.loggedTimer.time('GifEditor', 'parseGif');
        const worker = new Worker(new URL('./ParseGif.worker.ts', import.meta.url));
        worker.onerror = function(errorEvent) {
            console.error('worker onerror', worker, errorEvent);
            reject(errorEvent);
        };
        worker.onmessageerror = function(errorEvent) {
            console.error('worker onmessageerror', worker, errorEvent);
            reject(errorEvent);
        };
        worker.onmessage = function(e: MessageEvent) {
            console.log('e', e);
            context.loggedTimer.timeEnd('GifEditor', 'parseGif');
            resolve(e.data);
        };
        worker.postMessage(arrayBuffer, {transfer: [arrayBuffer]});
    });
}
